import * as PIXI from 'pixi.js'
import WordService from './wordservice'
import config from './config'
import NodeSystem from './system-node'
import PlayerSystem from './system-player'
import RenderSystem from './system-renderer'

import Events from './events'

class Game extends Events {
  // UI Listener (handler)
  constructor (el) {
    super()
    this.config = config
    this.sync = {}

    this.nodes = new NodeSystem(this)
    this.players = new PlayerSystem(this)
    this.renderer = new RenderSystem(this, el)

    // Frontend
    this.board = []
    // this.Players = {}

    this.$wordsvc = new WordService()
    this.$wordsvc.on('join', this.joined.bind(this))
    this.$wordsvc.on('start', this.started.bind(this))

    this.$wordsvc.on('teamUpdate', state => this.players.teamUpdate(state))
    this.$wordsvc.on('teamRemove', state => this.players.teamRemove(state))

    this.$wordsvc.on('playerUpdate', state => this.players.playerUpdate(state))
    this.$wordsvc.on('playerRemove', state => this.players.playerRemove(state))
    this.$wordsvc.on('playerDead', state => this.players.playerDead(state))
    this.$wordsvc.on('nodeAddChar', state => this.nodes.nodeAddChar(state))
    this.$wordsvc.on('nodeUpdate', state => this.nodes.nodeUpdate(state))
    this.$wordsvc.on('chunkInfo', state => this.nodes.chunkUpdate(state))
    this.$wordsvc.on('wordClaim', state => this.onWordClaim(state))
    this.$wordsvc.connected(() => {
      this.$wordsvc.m.iam(this.Name)
    })

    this.wheel = this.wheel.bind(this)
    this.sendKey = this.sendKey.bind(this)

    window.addEventListener('wheel', this.wheel)
    window.addEventListener('keydown', this.sendKey)
    // Monitor
    /* this.monitor = setInterval(() => {
      console.log('texture cache', Object.keys(PIXI.utils.TextureCache).length)
      console.log('Nodes:', this.nodes.nodeMap.size)
      console.log('Players:', this.players.playerMap.size)
      console.log('Teams:', this.players.teamMap.size)
    }, 5000) */

    // Add event listeners?
  }
  connect (ws, name) {
    this.board = []
    this.kills = 0
    this.score = 0
    this.Name = name
    this.$wordsvc.connect(ws)
  }
  destroy () {
    clearInterval(this.monitor)
    window.removeEventListener('wheel', this.wheel)
    window.removeEventListener('keydown', this.sendKey)
    this.$wordsvc && this.$wordsvc.close()
    this.$wordsvc = null
  }
  start (opt) {
    this.$wordsvc.m.start(opt)
  }

  // We received a join from server
  joined (state) {
    // MyPlayer
    this.ID = state.id
    this.follow = state.id
    this.room = state.room
    this.nodes.start()
    this.players.start()
    this.renderer.resetStage() // should we reset stage? maybe reset players stuff
    this.emit('joined', state)

    const playerPos = this.renderer.gridToPX(state.player.pos)
    this.renderer.pixi.worldMap.pivot.set(playerPos.x, playerPos.y)
    // TODO: Start request or do something else
    // this.$wordsvc.m.start()
  }
  started (state) {
    this.teamId = state.teamId
    this.renderer.pixiApp.stage.filters = this.renderer.pixi.filters.default
    this.playing = 2 // ?
    this.emit('started')
  }

  // When is this called?
  stateUpdate () {
    let teams
    if (this.room.teams) {
      teams = []
      // TODO improve this by listing players and pushing into teams
      // instead of listing teams and filtering players
      this.players.teamMap.forEach(t => {
        const players = Array.from(this.players.playerMap.values()).filter(p => {
          return p.state.teamId === t.id
        }).map(p => p.state)
        teams.push({
          id: t.id,
          color: t.color,
          name: t.name,
          players: players,
          score: t.score,
          mapRatio: (t.mapRatio * 100).toFixed(2)
        })
      })
    }

    // Team score too
    this.emit('state', {
      teamId: this.teamId,
      playing: this.playing,
      board: this.board,
      kills: this.kills || 0,
      score: this.score || 0,
      teams: teams
    })
  }
  onWordClaim (wordClaim) {
    this.renderer.wordClaim(wordClaim)
    this.emit('wordClaim', wordClaim)
  }
  calcBoard () {
    const pList = []
    this.players.forEach(p => p.state.curNode !== '' && pList.push(p.state))

    const top10 = pList.sort((a, b) => b.score - a.score).slice(0, 10)

    const ret = []
    for (let i = 0; i < 10; i++) {
      const p = top10[i]
      if (p) {
        ret.push(p)
      } else {
        ret.push({ name: '', wpm: '', score: '', color: 0xffffff })
      }
    }
    this.board = ret
    this.stateUpdate()
  }

  wheel (ev) {
    const s = Math.max(this.renderer.pixi.worldMap.scale.x - Math.sign(ev.deltaY) * 0.05, 0.1)
    window.localStorage.setItem('player.scale', s)
    this.renderer.pixi.worldMap.scale.set(s)
  }
  sendKey (ev) {
    ev.preventDefault()
    const player = this.players.playerGet(this.ID)
    if (!player || player.state.curNode === '') return
    if (ev.key.length === 1) { // basically if it is a char we send
      ev.stopPropagation()
      // Buffer the keys
      // Test the local thing
      // XXX: EXPERIMENT local animation
      if (config.clientSync) {
        this.nodes.surroundingForEach(player.state.pos, (n) => {
          if (!n) return
          const newMatch = (n.match || '') + ev.key
          if (n.state.word.indexOf(newMatch) !== 0) {
            n.match = undefined
            if (n.state.word[0] === ev.key) {
              n.match = ev.key
              this.nodes.nodeAddChar({ ch: ev.key, node: n.state, fromPlayer: this.ID }, true)
            }
            return
          }
          // Copy the node??
          n.match = newMatch
          this.nodes.nodeAddChar({ ch: ev.key, node: n.state, fromPlayer: this.ID }, true)
          if (newMatch !== n.state.word) {
            return
          }
          // WORD MATCH
          // Update surrounding nodes?
          this.nodes.forEach(n => n.selfMatchDelete())
          if (n.state.shield >= 1) return true

          // n.match = newMatch
          // n.set({ ...n.state, owner: this.ID })
          player.state.pos = n.state.pos
          player.state.curNode = n.state.id
          this.players.playerUpdate(player.state, true)
          // BREAK
          return true
        })
      }
      this.$wordsvc.m.sendChar(ev.key)
    }

    let move = []
    switch (ev.key) { // Special case
      case 'Escape':
        this.$wordsvc.m.sendChar('Escape')
        // simulate death
        break
        /* case 'F2':
          this.$wordsvc.m.start()
          break */
        /*
        case 'F3':
          this.$wordsvc.m.iam(this.playerName)
          break
        case 'F4':
          this.pixiApp.destroy()
          break */
      case 'Up':
      case 'ArrowUp':
        move = [0, -1]
        this.$wordsvc.m.sendChar('Up')
        break
      case 'Down':
      case 'ArrowDown':
        move = [0, 1]
        this.$wordsvc.m.sendChar('Down')
        break
      case 'Left':
      case 'ArrowLeft':
        move = [-1, 0]
        this.$wordsvc.m.sendChar('Left')
        break
      case 'Right':
      case 'ArrowRight':
        move = [1, 0]
        this.$wordsvc.m.sendChar('Right')
        break
    }

    // If room options says we delete chars on move
    if (this.config.clientSync && move.length > 0) {
      const pos = player.pos()
      const node = this.nodes.nodeGet(pos.x + move[0], pos.y + move[1])
      if (!node || node.state.ownerTeamId !== player.state.teamId) {
        return
      }
      if (this.room.resetMatchOnMove) this.nodes.forEach(n => n.selfMatchDelete())
      // Local move
      const newState = {
        ...player.state,
        pos: node.state.pos,
        curNode: node.state.node
      }
      this.players.playerUpdate(newState, true)
    }
  }
}
// Mixin
// Object.assign(Game.prototype, nodes)
// Object.assign(Game.prototype, PlayerSystem)
// Object.assign(Game.prototype, renderer)

export default Game
